import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { SCENARIOS, buildTiles, buildClock } from "@/data/breakageBoard.sample";
import { BreakageBoard } from "./BreakageBoard";
import LiveWall from "./LiveWall";

// 16px root up to 1920×1080; beyond that (wall monitors) the rem-based board scales up proportionally.
const FLUID_ROOT = "max(16px, min(calc(100vw / 120), calc(100vh / 67.5)))";

export default function BreakageBoardPage() {
  const [params] = useSearchParams();
  const desktop = useMediaQuery("(min-width: 1024px)");
  const key = SCENARIOS[params.get("scenario")] ? params.get("scenario") : null;
  const tiles = useMemo(() => (key ? buildTiles(SCENARIOS[key].states) : []), [key]);
  const clock = useMemo(() => (key ? buildClock(SCENARIOS[key].asOf) : null), [key]);

  useEffect(() => {
    if (!desktop) return undefined;
    const html = document.documentElement;
    html.style.fontSize = FLUID_ROOT;
    return () => {
      html.style.fontSize = "";
    };
  }, [desktop]);

  // No ?scenario= → the live wall (real mirror data). Scenario only for review previews.
  if (!key) return <LiveWall />;
  return <BreakageBoard key={key} tiles={tiles} clock={clock} variant={desktop ? "desktop" : "mobile"} />;
}
